var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReceipt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6602 2H6.66016C5.56016 2 4.67016 2.9 4.67016 4L4.66016 20C4.66016 21.1 5.55016 22 6.65016 22H18.6602C19.7602 22 20.6602 21.1 20.6602 20V8L14.6602 2ZM16.6602 18H8.66016V16H16.6602V18ZM16.6602 14H8.66016V12H16.6602V14ZM13.6602 9V3.5L19.1602 9H13.6602Z",
    fill: "#FFFFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceipt);
export default __webpack_public_path__ + "static/media/icon-receipt.4825e01fdecb23bc358c55285622091e.svg";
export { ForwardRef as ReactComponent };